module.exports = __webpack_public_path__ + "post-listing-block-3-image-1fiXDUA.jpg";